import { NgClass, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

type ButtonVariant = 'contained' | 'outline' | 'text';
type ButtonColor =
  | 'primary'
  | 'secondary'
  | 'error'
  | 'warning'
  | 'info'
  | 'success';

type ButtonSize = 'sm' | 'md' | 'lg';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [NgClass, NgIf],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss'
})
export class ButtonComponent {
  @Input() type: 'button' | 'submit' | 'reset' | null = null;

  @Input() disabled? = false;
  @Input() isLoading = false;

  @Input() variant: ButtonVariant = 'contained';
  @Input() color: ButtonColor = 'primary';
  @Input() size: ButtonSize = 'md';

  @Input() buttonClass = '';

  @Input() fullWidth: boolean = false;

  @Output() buttonClick = new EventEmitter<MouseEvent>();

  handleButtonClick(event: MouseEvent): void {
    this.buttonClick.emit(event);
  }
}